import { sendRequestAuth } from 'api/api'
import { removeAcent } from 'common/fieldText/_functions'
import { convertDateTimeToApiFormat } from 'common/form/datePicker/_functions'
import config from 'config'
import { useCallback, useContext } from 'react'
import { DateRangePicker } from 'rsuite'
import {
  COMMISSION_FILTER_TAG_FIELDS,
} from '../interfaces/_constants'
import { CommissionContext } from '../provider/_context'
import { commissionActions } from '../provider/_reducer'
import { debounce } from '@mui/material'
import { commissionInitialState } from 'Pages/commission/commissionPrincipal/provider/_initState'
import { useSearchParams } from 'react-router-dom'
import {formatDateTimeDefaultValue} from "../../commissionTeacher/provider/_reducer";

const useCommissionFilterForm = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { pageState, pageDispatch } = useContext(CommissionContext)
  const { filter, table } = pageState

  // ===== ===== ===== ===== =====
  // SEARCH
  // ===== ===== ===== ===== =====
  const searchValue = filter.search.value
  const querySearch = searchParams.get('search') || ''

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // DATE TIME
  // ===== ===== ===== ===== =====
  const { afterToday } = DateRangePicker
  const dateTimeActiveValue = filter.dateTime.activeValue
  const dateTimeDefaultValue = [filter.dateTime.end, filter.dateTime.start]
  const dateTimeEnd = filter.dateTime.end
  const dateTimeStart = filter.dateTime.start
  const dateTimeType = filter.dateTime.type
  const dateTimeValue = filter.dateTime.value
  const dateTimeTrigger = filter.dateTime.trigger

  const handleDateTimeChange = data =>
    pageDispatch({
      type: commissionActions.FILTER_DATE_TIME_UPDATE,
      payload: {
        end: data.value[1],
        start: data.value[0],
        type: data.category,
        value: data.formatValue,
      },
    })

  // ===== ===== ===== ===== =====
  // principal
  // ===== ===== ===== ===== =====
  const principalActiveValue = filter.principal.activeValue
  const principalKeyword = filter.principal.keyword
  const principalList = filter.principal.list
  const principalListOrigin = filter.principal.listOrigin
  const principalValue = filter.principal.value

  const handlePrincipalChange = async (data) => {
    pageDispatch({
      type: commissionActions.FILTER_PRINCIPAL_UPDATE,
      payload: { value: data },
    })
    // get list teacher
    const response = await sendRequestAuth('get', `${config.API}/commission/filter/teachers?principal_id=${data?.value}`)
    pageDispatch({
      type: commissionActions.FILTER_TEACHER_LIST_UPDATE,
      payload: {
        teacher: {
          list: response.data?.map(item => ({
            name: item?.name || '',
            value: item?.id || '',
          })),
        }
      },
    })

  }

  const handlePrincipalKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const principalListData = principalListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: commissionActions.FILTER_PRINCIPAL_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: principalListData,
      },
    })
  }
// ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // Teacher
  // ===== ===== ===== ===== =====
  const teacherActiveValue = filter.teacher.activeValue
  const teacherKeyword = filter.teacher.keyword
  const teacherList = filter.teacher.list
  const teacherListOrigin = filter.teacher.listOrigin
  const teacherValue = filter.teacher.value

  const handleTeacherChange = data =>
    pageDispatch({
      type: commissionActions.FILTER_TEACHER_UPDATE,
      payload: { value: data },
    })

  const handleTeacherKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const teacherListData = teacherListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: commissionActions.FILTER_TEACHER_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: teacherListData,
      },
    })
  }

// ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // order Type
  // ===== ===== ===== ===== =====
  const orderTypeActiveValue = filter.orderType.activeValue
  const orderTypeKeyword = filter.orderType.keyword
  const orderTypeList = filter.orderType.list
  const orderTypeValue = filter.orderType.value

  const handleOrderTypeChange = data =>
    pageDispatch({
      type: commissionActions.FILTER_ORDER_TYPE_UPDATE,
      payload: { value: data },
    })

  // ===== ===== ===== ===== =====
  // COMMISSION ID
  // ===== ===== ===== ===== =====
  const orderIdValue = filter.orderId.value
  const orderIdActiveValue = filter.orderId.activeValue

  const handleCommissionIdChange = value => {
    if (value === ' ') value = ''
    pageDispatch({
      type: commissionActions.FILTER_COMMISSION_ID_UPDATE,
      payload: { value: value },
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // CUSTOMER INFO
  // ===== ===== ===== ===== =====
  const customerInfoValue = filter.customerInfo.value
  const customerInfoActiveValue = filter.customerInfo.activeValue

  const handleCustomerInfoChange = value => {
    if (value === ' ') value = ''
    pageDispatch({
      type: commissionActions.FILTER_CUSTOMER_INFO_UPDATE,
      payload: { value: value },
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  const canSubmitOtherFilter = [
    dateTimeActiveValue.value !== dateTimeValue ||
    JSON.stringify(dateTimeActiveValue.type) !== JSON.stringify(dateTimeType),
    JSON.stringify(orderTypeActiveValue) !== JSON.stringify(orderTypeValue),
    JSON.stringify(principalActiveValue) !== JSON.stringify(principalValue),
    JSON.stringify(teacherActiveValue) !== JSON.stringify(teacherValue),
    JSON.stringify(orderIdActiveValue) !== JSON.stringify(orderIdValue),
    JSON.stringify(customerInfoActiveValue) !== JSON.stringify(customerInfoValue),
  ].includes(true)

  const queries = {
    date_type: dateTimeActiveValue?.type?.value || '',
    start_date:
      dateTimeActiveValue?.start && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[0])
        : '',
    end_date:
      dateTimeActiveValue?.end && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[1])
        : '',
    type: orderTypeActiveValue?.value || '',
    principal_id: principalActiveValue?.value || '',
    teacher_id: teacherActiveValue?.value || '',
    order_id: orderIdActiveValue || '',
    customer: customerInfoActiveValue || '',
    per_page: table?.pagination?.amount || 20,
    start: 0,
  }

  const debounceCommissionByFilter = useCallback(debounce((keyword, queries) => {
    fetchCommissionByFilter(
      { ...queries, keyword: keyword.trim() },
      { forceLoading: true },
    )
  }, 500), [queries])

  const handleSearchChange = e => {
    if (e.target.value === ' ') e.target.value = ''
    const keyword = e.target.value.replace(/\s+/g, ',') || ''
    pageDispatch({
      type: commissionActions.FILTER_SEARCH_UPDATE,
      payload: { value: keyword },
    })
    debounceCommissionByFilter(keyword.trim().split(' ').join(','), queries)
    // if(keyword.trim().length > 0) debounceCommissionByFilter(keyword.trim().split(' ').join(','))
  }

  const applyCommissionOtherFilter = async () => {
    const collection = {
      ...queries,
      date_type: dateTimeType?.value || '',
      start_date:
        dateTimeStart && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[0])
          : '',
      end_date:
        dateTimeEnd && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[1])
          : '',
      type: orderTypeValue?.value || '',
      principal_id: principalValue?.value || '',
      teacher_id: teacherValue?.value || '',
      customer: customerInfoValue || '',
      order_id: orderIdValue || '',
    }
    fetchCommissionByFilter(collection, { forceLoading: true , pageOption: pageState?.pageOption?.value})
  }

  const fetchCommissionByFilter = async (qs, opt) => {
    setSearchParams('')
    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: true } } },
      })

    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/report/commission/${opt?.pageOption||'date'}${queryString}`),
    ])

    if (!!response[0]?.data?.success) {
      pageDispatch({
        type: commissionActions.OTHER_FILTER_APPLY,
        payload: {
          display: {
            list: response[0].data.data
          },
          pagination: {
            active: opt?.activePage || 0,
            amount: table.pagination.amount,
            total: response[0]?.data?.meta?.total
              ? Math.ceil(
                response[0]?.data?.meta?.total / table.pagination.amount,
              )
              : 0,
            totalItems: response[0]?.data?.meta?.total || 0,
          },
        },
      })

      pageDispatch({
        type: commissionActions.PANELS_UPDATE,
        payload: response[0]?.data?.meta
      })
    }

    if (!!!opt?.notClearDetail)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: null },
      })

    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })

    pageDispatch({
      type: commissionActions.TABLE_DISPLAY_DETAIL_ID_UPDATE,
      payload: { id: null },
    })
  }
const fetchCommissionByTagDelete = async (qs, opt) => {
    setSearchParams('')
    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: true } } },
      })

    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/report/commission/${opt?.pageOption||'date'}${queryString}`),
    ])

    if (!!response[0]?.data?.success) {
      pageDispatch({
        type: commissionActions.DELETE_TAG_UPDATE,
        payload: {
          display: {
            list: response[0].data.data
          },
          pagination: {
            active: opt?.activePage || 0,
            amount: table.pagination.amount,
            total: response[0]?.data?.meta?.total
              ? Math.ceil(
                response[0]?.data?.meta?.total / table.pagination.amount,
              )
              : 0,
            totalItems: response[0]?.data?.meta?.total || 0,
          },
        },
      })

      pageDispatch({
        type: commissionActions.PANELS_UPDATE,
        payload: response[0]?.data?.meta
      })
    }

    if (!!!opt?.notClearDetail)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: null },
      })

    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: commissionActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })

    pageDispatch({
      type: commissionActions.TABLE_DISPLAY_DETAIL_ID_UPDATE,
      payload: { id: null },
    })
  }

  const filterTagDelete = t => {
    pageDispatch({
      type: commissionActions.TAG_FILTER_DELETE,
      payload: { type: t, isSingle: true },
    })

    let tmpCollection = {}
    switch (t) {
      case 'dateTime.current':
        tmpCollection = {
          ...tmpCollection,
          date_type: '',
          start_date: '',
          end_date: '',
        }

        pageDispatch({
          type: commissionActions.FILTER_DATE_TIME_TRIGGER_UPDATE,
          payload: { trigger: null },
        })

        break

      case COMMISSION_FILTER_TAG_FIELDS[8]:
        tmpCollection = {
          ...tmpCollection,
        }
        break

      case COMMISSION_FILTER_TAG_FIELDS[0]:
        tmpCollection = {
          ...tmpCollection,
          order_id: ''
        }
        break

      case COMMISSION_FILTER_TAG_FIELDS[1]:
        tmpCollection = { ...tmpCollection, customer: '' }
        break

      case COMMISSION_FILTER_TAG_FIELDS[2]:
        tmpCollection = { ...tmpCollection, type: '' }
        break

      case COMMISSION_FILTER_TAG_FIELDS[3]:
        tmpCollection = { ...tmpCollection, principal_id: '' }
        break

      case COMMISSION_FILTER_TAG_FIELDS[4]:
        tmpCollection = { ...tmpCollection, teacher_id: '' }
        break


      default:
        break
    }

    const collection = { ...queries, ...tmpCollection }

    fetchCommissionByTagDelete(collection, { forceLoading: true,pageOption: pageState?.pageOption?.value })
  }

  const filterTagDeleteAll = isSoft => {
    COMMISSION_FILTER_TAG_FIELDS.forEach(item =>
      pageDispatch({
        type: commissionActions.TAG_FILTER_DELETE,
        payload: { type: item },
      }),
    )

    pageDispatch({
      type: commissionActions.FILTER_DATE_TIME_TRIGGER_UPDATE,
      payload: {
        trigger: dateTimeTrigger === null ? true : !dateTimeTrigger,
      },
    })

    if (isSoft) return

    const date = formatDateTimeDefaultValue.split(' - ')
    const collection = {
      ...queries,
      date_type: 'created',
      start_date: convertDateTimeToApiFormat(date[0]),
      end_date: convertDateTimeToApiFormat(date[1]),
      user_id: '',
      type: '',
      principal_id: '',
      teacher_id: '',
      customer: '',
      order_id: '',
    }

    fetchCommissionByFilter(collection, { forceLoading: true,pageOption: pageState?.pageOption?.value })
  }

  return {
    pageState,
    dateTime: {
      activeValue: dateTimeActiveValue,
      defaultValue: dateTimeDefaultValue,
      disabledDate: afterToday(),
      triggerDefault: dateTimeTrigger,
      value: dateTimeValue,
      onChange: handleDateTimeChange,
    },

    orderType: {
      activeValue: orderTypeActiveValue,
      keyword: orderTypeKeyword,
      list: orderTypeList,
      value: orderTypeValue,
      onChange: handleOrderTypeChange,
    },
    search: {
      value: searchValue,
      onChange: handleSearchChange,
    },
    orderId: {
      value: orderIdValue,
      activeValue: orderIdActiveValue,
      onChange: handleCommissionIdChange,
    },
    customerInfo: {
      value: customerInfoValue,
      activeValue: customerInfoActiveValue,
      onChange: handleCustomerInfoChange,
    },
    principal: {
      activeValue: principalActiveValue,
      keyword: principalKeyword,
      list: principalList,
      value: principalValue,
      onChange: handlePrincipalChange,
      onKeywordChange: handlePrincipalKeywordChange,
    },
    teacher: {
      activeValue: teacherActiveValue,
      keyword: teacherKeyword,
      list: teacherList,
      listOrigin: teacherListOrigin,
      value: teacherValue,
      onChange: handleTeacherChange,
      onKeywordChange: handleTeacherKeywordChange,
    },
    canSubmitOtherFilter,
    queries,
    functions: {
      hasFilter: () => [
        JSON.stringify(dateTimeActiveValue?.value) !==
        JSON.stringify(commissionInitialState.filter.dateTime.activeValue?.value),
        !!principalActiveValue?.name,
        !!orderTypeActiveValue?.name,
        !!teacherActiveValue?.name,
        !!orderIdActiveValue,
        !!customerInfoActiveValue,
      ].includes(true),
      applyCommissionOtherFilter,
      refresh: (pageOption) =>
        fetchCommissionByFilter(
          {
            ...queries,
            start: table.pagination.active * table.pagination.amount || 0,
          },
          { activePage: table.pagination.active, forceLoading: true, pageOption: pageOption},
        ),
      pageOption: (pageOption) =>
        fetchCommissionByFilter(
          {
            ...queries,
            start: 0,
          },
          { activePage: 0, forceLoading: true, pageOption: pageOption},
        ),
      fetchUpdateData: () =>
        fetchCommissionByFilter(
          {
            ...queries,
            start: table.pagination.active * table.pagination.amount,
          },
          { activePage: table.pagination.active, notClearDetail: true },
        ),
      filterTagDelete,
      filterTagDeleteAll,
    },
  }
}

export default useCommissionFilterForm
